angular
  .module('contributor')

  .factory('UpdateTasksCountersCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class UpdateTasksCountersCrud extends Crud {
        constructor() {
          super(null, '@@apiUrl' + '/set-tasks-counters', {}, {});
        }
      }
      return UpdateTasksCountersCrud;
    }
  ]);
